import SectionComparisonTable from './SectionComparisonTable';
export default SectionComparisonTable;
